import { render, staticRenderFns } from "./PluginGoogleAnalytics.vue?vue&type=template&id=5ee03def"
import script from "./PluginGoogleAnalytics.vue?vue&type=script&lang=js"
export * from "./PluginGoogleAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ee03def')) {
      api.createRecord('5ee03def', component.options)
    } else {
      api.reload('5ee03def', component.options)
    }
    module.hot.accept("./PluginGoogleAnalytics.vue?vue&type=template&id=5ee03def", function () {
      api.rerender('5ee03def', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginGoogleAnalytics.vue"
export default component.exports